<template>
  <div>
    <!-- <Header /> -->

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="flex">
      <SideBar />

      <!-- {{  studentList }} -->

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <!-- {{ userSelectList }} -->
        <div
          class="px-10 py-10 flex items-center justify-end gap-10"
          v-if="this.userSelectList != 0"
        >
          <div class="flex items-center justify-end gap-5">
            <button
              class="bg-blues text-white px-5 py-2 rounded-2xl font-semibold text-sm"
              @click="addStudents"
            >
            Add Students
            </button>
          </div>
        </div>

        <table class="table-auto w-full overflow-x-auto">
          <thead>
            <tr>
              <th
                class="p-4 border-b text-center border-r text-blues whitespace-nowrap"
                :class="{ 'border-t': this.userSelectList != 0 }"
              >
                Select
              </th>
              <th
                class="p-4 border-b text-center border-r text-blues whitespace-nowrap"
                :class="{ 'border-t': this.userSelectList != 0 }"
              >
                S NO
              </th>
              <th
                class="p-4 border-b text-center border-r text-blues"
                :class="{ 'border-t': this.userSelectList != 0 }"
              >
                Name
              </th>
              <th
                class="p-4 border-b text-center text-blues"
                :class="{ 'border-t': this.userSelectList != 0 }"
              >
                Email
              </th>
              <!-- <th
                class="p-4 border-b text-center border-r text-blues"
                :class="{ 'border-t': this.userSelectList != 0 }"
              >
                Last login
              </th> -->
             
            </tr>
          </thead>
          <tbody v-if="loading" style="height: calc(100vh - 350px) !important">
            <tr class="w-full">
              <td colspan="8" class="text-center py-6">
                <div class="flex items-center justify-center">
                  <img src="@/assets/newd/loading.gif" alt="" />
                </div>
              </td>
            </tr>
          </tbody>
          <tbody
            v-else-if="
              studentList &&
              !loading
            "
          >
            <tr v-for="(el, index) in this.studentList" :key="el.user.id">
              <td class="p-4 border-b text-center border-r">
                <!-- <p class="text-primary">{{ index + 1 }}</p> -->
                <input
                  type="checkbox"
                  :value="el.user.id"
                  v-model="userSelectList"
                  name=""
                  id=""
                />
              </td>
            
              <td class="p-4 border-b text-center border-r">
                <p class="text-primary">{{ (currentPage - 1) * 10 + index + 1 }}</p>
              </td>
              <td class="p-4 border-b text-center border-r">
                <p v-if="el.user.display_name" class="text-primary">
                  {{ el.user.display_name }}
                </p>
                <p v-else class="text-primary">NA</p>
              </td>
              <td class="p-4 border-b text-center">
                <p class="text-primary">{{ el.user.email }}</p>
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr class="w-full">
              <td colspan="8" class="text-center py-6">
                <div class="w-full flex justify-center items-center">
                  No Data Found
                </div>
              </td>
            </tr>
          </tbody>
        </table> 

        <Pagination :totalPages="totalPages" ref="paginationRef" @page-changed="getstudentdetails" />

      </div>

      

    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";
import FlashMessage from "@/components/FlashMessage.vue";

import axios from "axios";
import { mapGetters } from "vuex";

import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Header,
    SideBar,
    FlashMessage,
    Pagination
  },
  data() {
    return {
      userSelectList: [],
      popUpAll: false,
      popupMailAll: false,
      popUp: false,
      minimize: true,
      maximize: false,
      studentList: null,
      mailid: null,
      messages: {
        text: "",
        type: "null",
      },
      loading: true,
      courseInfo: "",
      totalPages: 1,
      currentPage: 1
    };
  },
  created() {
    this.getstudentdetails(1);
  },

  props: ["course_id", "department_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },
  methods: {
    async addStudents() {
      await axios
        .post(
          `${process.env.VUE_APP_API}/assign-student-permission/?Key=${this.userInfo.token_key}`,
          {
            courses: [this.course_id],
            users: this.userSelectList,
          }
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: response.data.message,
              type: "success",
            };
            // this.$refs.mailrefbulk.reset();
            // this.popUpAll = false;
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.userSelectList = [];
              this.getstudentdetails(1);
            }, 1500);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 1500);
          }
        });
    },


    async getstudentdetails(page) {
      this.currentPage = page;
      await axios
        .get(
          `${process.env.VUE_APP_API}/student/detail/list/?Key=${this.userInfo.token_key}&department__id=${this.department_id}&page=${page}&course_id=${this.course_id}`
        )
        .then((response) => {
            this.totalPages = response.data.total_page;
            this.studentList = response.data.data.data;
            this.loading = false;
        });
    },

  
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
